import $http from "../../axios";
import { Notification, MessageBox } from "element-ui";


export async  function setPerPagePagination({ commit, dispatch }, perPage) {
    commit("setPerPage", parseInt(perPage.target.value));
    dispatch("getDataphones");

  }

  export async function setPagePagination({ commit, dispatch }, page) {
    commit("setPage", parseInt(page));
    dispatch("getDataphones");
  }

  export async function getDataphones({state,commit}){
      await $http.get('/api/dataphones',{params:state.params}).then(response=>{
           commit('setDataphones',response.data);
      }).catch(error=>{})
  }

  export async function createDataphones({state,commit}){
    $http.post('/api/dataphones',state.selectedDataphone).then(response=>{
      Notification.success({
        title: "Exito!",
        message: "Datafono Creado  Correctamente",
        type: "success",
        duration: 2000,
        customClass: "notification-box"
      });

    }).catch(error=>{
      Notification.error({
        title: "error!",
        message: error.message,
        type: "error",
        duration: 2000,
        customClass: "notification-box"
      });
    })
  }


  export async  function getDataphoneById( {commit}, id) {
    await $http.get(`/api/dataphones/${id}`).then(response=>{
      commit('setSelectedDataphone',response.data.data);
    }).catch(error=>{
      Notification.error({
        title: "error!",
        message: error.message,
        type: "error",
        duration: 2000,
        customClass: "notification-box"
      });
    });

  }

  export async function updateDataphone({state}){
    $http.put(`/api/dataphones/${state.selectedDataphone.id}`, state.selectedDataphone).then(resposnse=>{
      Notification.success({
        title: "Exito!",
        message: 'Se ha Actualizado Correctamente el Datafono',
        type: "success",
        duration: 2000,
        customClass: "notification-box"
      });
    }).catch(error=>{
      Notification.error({
        title: "error!",
        message: error.message,
        type: "error",
        duration: 2000,
        customClass: "notification-box"
      });
    });

  }

  export async function deleteDataphoneById({},id) {
   await  $http.delete(`/api/dataphones/${id}`).then(response=>{
    Notification.success({
      title: "Exito!",
      message: 'Se ha Eliminado Correctamente el Datafono',
      type: "success",
      duration: 2000,
      customClass: "notification-box"
    });
    }).catch(error=>{
      Notification.error({
        title: "error!",
        message: error.message,
        type: "error",
        duration: 2000,
        customClass: "notification-box"
      });
    });
  }





// WEBPACK FOOTER //
// ./src/modules/dataphones/actions.js